import React from "react";

const BoltIcon = ({ className }: { className?: string }) => (<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_863_624"       style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="31">
<rect width="31" height="31" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_863_624)">
<path d="M13.6245 23.508L20.3089 15.4997H15.1422L16.0786 8.16947L10.1047 16.7913H14.5932L13.6245 23.508ZM10.3307 28.4163L11.6224 19.3747H5.16406L16.7891 2.58301H19.3724L18.0807 12.9163H25.8307L12.9141 28.4163H10.3307Z" fill="white"/>
</g>
</svg>);

export default BoltIcon;

